import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { ReactNode } from 'react';

type BenefitRowProps = {
    children: ReactNode;
    icon: ReactNode;
};

export const BenefitRow = ({ children, icon }: BenefitRowProps) => (
    <div className="flex w-full items-center gap-sm">
        <div className="flex size-xl shrink-0 items-center justify-center rounded-xs bg-background-secondary">
            {icon}
        </div>
        <BodyPrimary className="flex-1">{children}</BodyPrimary>
    </div>
);
